import React, { useState, useEffect } from 'react';
import { fetchScientificArticles } from '../services/PDFLibraryRepository';

const PDFLibrary = () => {
    const [materials, setMaterials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadMaterials = async () => {
            try {
                const articles = await fetchScientificArticles();
                setMaterials(articles);
            } catch (e) {
                console.error("Erro biblioteca:", e);
            } finally {
                setLoading(false);
            }
        };
        loadMaterials();
    }, []);

    const handleDownload = (link) => {
        if (!link) return alert("Link indisponível.");
        window.open(link, '_blank');
    };

    if (loading) return <div className="text-center py-20"><i className="fas fa-circle-notch fa-spin text-3xl text-[#C5A059]"></i></div>;

    return (
        <div className="max-w-6xl mx-auto pb-20 animate-fade-in">
            <header className="mb-8 flex justify-between items-end border-b border-gray-200 pb-6">
                <div>
                    <h2 className="text-3xl font-bold text-[#20243B] flex items-center gap-3">
                        <i className="fas fa-book-reader text-[#C5A059]"></i> Biblioteca Digital
                    </h2>
                    <p className="text-sm text-gray-500 mt-2">Acervo de apostilas, mapas mentais e legislação comentada.</p>
                </div>
                <span className="text-xs font-bold bg-gray-100 text-gray-500 px-3 py-1 rounded-full">{materials.length} Arquivos</span>
            </header>
            
            {materials.length === 0 ? (
                <div className="text-center py-20 bg-gray-50 rounded-xl border border-dashed border-gray-300">
                    <i className="fas fa-folder-open text-4xl text-gray-300 mb-4"></i>
                    <p className="text-gray-500 font-bold">Biblioteca em atualização.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {materials.map((item) => (
                        <div key={item.id} className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:border-[#C5A059] transition-all group relative overflow-hidden flex flex-col h-full">
                            <div className="flex items-start gap-4 mb-4">
                                <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center text-red-500 shrink-0 group-hover:scale-110 transition-transform">
                                    <i className="fas fa-file-pdf text-xl"></i>
                                </div>
                                <div>
                                    <span className="text-[10px] font-bold bg-gray-100 text-gray-500 px-2 py-1 rounded uppercase tracking-wider">
                                        {item.category || 'Geral'}
                                    </span>
                                    <h3 className="font-bold text-[#20243B] mt-2 leading-tight line-clamp-2" title={item.title}>
                                        {item.title}
                                    </h3>
                                    <p className="text-xs text-gray-400 mt-1">
                                        {item.pages ? `${item.pages} páginas • ` : ''} 
                                        {item.createdAt ? new Date(item.createdAt.seconds * 1000).toLocaleDateString('pt-BR') : 'Recente'}
                                    </p>
                                </div>
                            </div>
                            
                            <div className="mt-auto pt-4 border-t border-gray-100">
                                <button 
                                    onClick={() => handleDownload(item.link)} 
                                    className="w-full bg-[#20243B] text-white py-2 rounded text-xs font-bold uppercase hover:bg-[#1a1e30] flex items-center justify-center gap-2 transition-transform active:scale-95"
                                >
                                    <i className="fas fa-download"></i> Baixar Material
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PDFLibrary;